import { render, staticRenderFns } from "./EventTabQuestionsAndStatistics.vue?vue&type=template&id=8b7adad2&"
import script from "./EventTabQuestionsAndStatistics.vue?vue&type=script&lang=js&"
export * from "./EventTabQuestionsAndStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports